/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Settings_Fields_Alipay_App_IdInputs */

const en_admin_settings_fields_alipay_app_id = /** @type {(inputs: Admin_Settings_Fields_Alipay_App_IdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`App ID`)
};

/**
* | output |
* | --- |
* | "App ID" |
*
* @param {Admin_Settings_Fields_Alipay_App_IdInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const admin_settings_fields_alipay_app_id = /** @type {((inputs?: Admin_Settings_Fields_Alipay_App_IdInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Settings_Fields_Alipay_App_IdInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_admin_settings_fields_alipay_app_id(inputs)
});
export { admin_settings_fields_alipay_app_id as "admin.settings.fields.alipay_app_id" }